module.exports = __webpack_public_path__ + "img/rejadeacero.2c51c4e8.jpg";